// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"24fd92c6254cc89e","9777":"e9b07df730016fa7"}[chunkId] + ".js";
};